import { Component, OnInit } from '@angular/core';
import { HttpUtilService } from '@services/http-util.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';

@Component({
    selector: 'app-data-list',
    templateUrl: './data-list.component.html',
    styleUrls: ['./data-list.component.scss']
})
export class DataListComponent implements OnInit {
    
    constructor(private httpUtils : HttpUtilService, private route: ActivatedRoute, private router : Router) { }
    
    type = null;
    items = null;
    view  = null;
    
    ngOnInit() {
        this.route.paramMap.subscribe( params => {
            this.type = params.get('type');
            this.getDataList();
        })        
    }
    
    private getDataList() {
        this.httpUtils.authGet(environment.apiRoot + '/' + this.type +'/select?mode=read').subscribe( data => {
            this.view = data
            // if (data && data.listItems) {
            //     if (Array.isArray(data.listItems)){
            //         this.items = data.listItems;
            //     } else {
            //         this.items = [data.listItems]
            //     }
            // }
        })
    }

    editPage() {
        this.router.navigate(['edit'], { relativeTo: this.route });
    }
    
}
